import {DisplayOptionsModel} from "../../models/tasks/DisplayOptionsModel";

export class DisplayOptionsCtrl {
    public static $inject = ['$scope','DisplayOptionsModel'];
    constructor(public $scope:any, public model:DisplayOptionsModel) {
        $scope.vm = this;
    }
}
